import { env } from '@src/config/env';
import { reportNetworkError } from '@src/context/NetworkStatusContext';

export interface PunchMappingResult {
    employee_id: string;
    user_id: number;
}

/**
 * Resolves a partner external user ID to the employee's internal ID (PIN) via
 * the punch-mapping endpoint. Requires a location-scoped integration mapping.
 *
 * @throws Error with a `status` property on non-ok responses.
 */
export async function fetchPunchMapping(
    companyId: number,
    applicationName: string,
    locationId: number,
    externalUserId: string,
    accessToken: string
): Promise<PunchMappingResult> {
    const url = new URL(
        `${env.apiBaseUrl}/api/v2/company/${companyId}/integrations/${encodeURIComponent(applicationName)}/punch-mapping`
    );
    url.searchParams.set('location_id', String(locationId));
    url.searchParams.set('external_user_id', externalUserId);

    let res: Response;
    try {
        res = await fetch(url.toString(), {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                Accept: 'application/json'
            }
        });
    } catch (err) {
        reportNetworkError();
        throw err;
    }

    if (!res.ok) {
        const err = new Error(
            `Punch mapping fetch failed (${res.status})`
        ) as Error & { status: number };
        err.status = res.status;
        throw err;
    }

    const json = await res.json();
    return json.data as PunchMappingResult;
}
